<template>
    <div class="columns">

        <div class="column is-one-quarter" v-if="gameData.gameType == 'Tournament'">
            <h1 class="title is-size-4">Sets <i class="fas fa-info-circle"></i></h1>
            <div class="select is-rounded">
                <select v-model="mutatable_sets">
                    <option>1</option>
                    <option>2</option>
                    <option>3</option>
                    <option>4</option>
                    <option>5</option>
                    <option>6</option>
                    <option>7</option>
                </select>
            </div>
        </div>
        <div class="column is-one-quarter" v-else>
        </div>

        <div class="column is-one-quarter">
            <h1 class="title is-size-4">Rounds <i class="fas fa-info-circle"></i></h1>
            <div class="select is-rounded">
                <select v-model="mutatable_rounds">
                    <option>1</option>
                    <option>2</option>
                    <option>3</option>
                    <option>4</option>
                    <option>5</option>
                    <option selected>6</option>
                </select>
            </div>
        </div>

        <div class="column is-one-quarter">
            <h1 class="title is-size-4">Throws  <i class="fas fa-info-circle"></i></h1>
            <div class="select is-rounded">
                <select v-model="mutatable_throws">
                    <option>1</option>
                    <option>2</option>
                    <option>3</option>
                    <option>4</option>
                    <option>5</option>
                    <option>6</option>
                </select>
            </div>
        </div>

        <div class="column is-one-quarter" v-if="gameData.gameType == 'Tournament'">
            <h1 class="title is-size-4">Targets  <i class="fas fa-info-circle"></i></h1>
            <div class="select is-rounded">
                <select v-model="mutatable_targets">
                    <option>1</option>
                    <option>2</option>
                    <option>3</option>
                    <option>4</option>
                    <option>5</option>
                    <option>6</option>
                    <option>7</option>
                    <option>8</option>
                    <option>9</option>
                    <option>10</option>
                </select>
            </div>
        </div>
        <div class="column is-one-quarter" v-else>
        </div>

</div>
</template>

<script>
  export default {
    name: 'ThrowSettings',
    methods: {
    },
    props: ['gameData','sets','rounds','throws','targets'],
    data () {
        return {
            mutatable_sets: null,
            mutatable_rounds: null,
            mutatable_throws: null,
            mutatable_targets: null
        }
    }, 
    watch: {
        mutatable_sets(new_value, old_value) {
            //console.log("sets", old_value, new_value);
            this.$parent.setSets(new_value);
        },
        mutatable_rounds(new_value, old_value) {
            //console.log("rounds", old_value, new_value);
            this.$parent.setRounds(new_value);
        },
        mutatable_throws(new_value, old_value) {
            //console.log("throws", old_value, new_value);
            this.$parent.setThrows(new_value);
        },
        mutatable_targets(new_value, old_value) {
            //console.log("targets", old_value, new_value);
            this.$parent.setTargets(new_value);
        }
    },    
    computed: {
    },
    mounted(){
        this.mutatable_sets = this.sets;
        this.mutatable_rounds = this.rounds;
        this.mutatable_throws = this.throws;
        this.mutatable_targets = this.targets;
    }
  }
</script>

<style scoped>

</style>